import Packery from "packery";

export default function () {

    const grids = document.querySelectorAll('.js-packery');

    function gridCheck() {
        const width = window.innerWidth;
        for (const grid of grids) {
            const status = grid.getAttribute('data-p');
            const pckry = new Packery( grid, {
                itemSelector: '.pathways__item'
            });
        }
    }

    if (grids && grids.length) {
        gridCheck();
    }

}
